import React from 'react'
import {observer} from 'mobx-react-lite'
import {Flex, Text} from '../../vanilla'
import {useOrderStore, useBasketStore} from '../../store/hooks/useStore'
import {FormattedNumber} from 'react-intl'
interface ShoppingTotalProps {
  inDrawer?: boolean
}

export const ShoppingTotal = observer(({inDrawer}: ShoppingTotalProps) => {
  const {orderTotal} = useOrderStore()
  const {basket, headerShoppingTotal} = useBasketStore()

  // Mini-cart keeps the full order total (PWA-2188). Header omits the small
  // basket fee until min spend to checkout is met (PWA-2196).
  const displayTotal = inDrawer ? orderTotal : headerShoppingTotal

  return (
    <Flex flexDirection="column" align="flex-end">
      <Text
        variant="unstyled"
        fontSize={inDrawer ? 'md' : 'xs'}
        fontWeight={inDrawer ? 'normal' : ['normal', 'medium']}
        as="span"
        lineHeight="none"
        data-test-selector={inDrawer ? 'cart-drawer-basket-total' : 'basket-total-amount'}
      >
        {displayTotal ? (
          <FormattedNumber style="currency" currency={basket?.currency} value={displayTotal} />
        ) : (
          '£0.00'
        )}
      </Text>
      <Text
        color="textMuted"
        variant="unstyled"
        fontSize="xxs"
        fontWeight="normal"
        lineHeight="none"
        data-test-selector="inc-fees-text"
      >
        inc. fees
      </Text>
    </Flex>
  )
})
